import React from "react";
import styled from "styled-components";
import { AppButton } from "site/ui";

const ModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-family: "Manrope", sans-serif;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 375px;
  padding: 30px 25px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const WarningIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #ffc107;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 24px;
  font-weight: bold;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 30px;
  line-height: 1.5;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-top: 10px;
`;

const CancelButton = styled(AppButton)`
  flex: 1;
`;

const DeleteButton = styled(AppButton)`
  flex: 1;
`;

interface DeleteAccountConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const DeleteAccountConfirmation: React.FC<DeleteAccountConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <ModalOverlay isOpen={isOpen}>
      <ModalContent>
        <WarningIcon>!</WarningIcon>

        <Title>Are you sure you want to delete your account?</Title>

        <Description>
          Once deleted, it will be permanently removed and cannot be recovered.
          This action is irreversible.
        </Description>

        <ButtonContainer>
          <CancelButton
            variant="secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            No
          </CancelButton>

          <DeleteButton
            variant="delete"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Yes, delete"}
          </DeleteButton>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DeleteAccountConfirmation;
